/* eslint-disable */
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../config/config";
import Select from "react-select";
import DatePicker from "react-multi-date-picker";
import arabic from "react-date-object/calendars/arabic";
import arabic_ar from "react-date-object/locales/arabic_ar";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AddContractLight({ lang }) {
  const { id } = useParams();
  const token = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin"))?.admin,
  )?.token;
  const admin = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin")).admin,
  );
  const branchId = admin.branch_id;
  const navigate = useNavigate();
  const pathName = useLocation();

  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [investorLoading, setInvestorLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  let savedCustomer =
    new URLSearchParams(pathName.search).get("customer") || "";
  savedCustomer = parseInt(savedCustomer);

  // Basic Info
  const [customerList, setCustomerList] = useState([]);
  const [customer, setCustomer] = useState(savedCustomer);

  // Identification Info
  const [itemsList, setItemsList] = useState([]);
  const [investors, setInvestors] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [item, setItem] = useState();
  const [investor, setInvestor] = useState();
  const [quantity, setQuantity] = useState();
  const [totalQuantity, setTotalQuantity] = useState();
  const [totalPurchase, setTotalPurchase] = useState();
  const [totalSellPrice, setTotalSellPrice] = useState();
  const [available, setAvailable] = useState();
  const [capital, setCapital] = useState();
  const [unitPrice, setUnitPrice] = useState();
  const [profit, setProfit] = useState();
  const [legalFees, setLegalFees] = useState(0);
  const [description, setDescription] = useState();
  const [descriptionTemplates, setDescriptionTemplates] = useState([]);
  const [notes, setNotes] = useState();

  // Contract Info
  const [contractType, setContractType] = useState(1);
  const [accountList, setAccountList] = useState([]);
  const [account, setAccount] = useState();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedCalendar, setSelectedCalendar] = useState("gregorian");
  const [selectedScheduleType, setSelectedScheduleType] = useState();
  const [nextScheduledDate, setNextScheduledDate] = useState();
  const [contractValue, setContractValue] = useState();
  // const [premium] = useState();
  const [downPayment, setDownPayment] = useState(0);
  const [remaining, setRemaining] = useState();
  const [noInstallment, setNoInstallment] = useState(1);
  const [finalInstallment, setFinalInstallment] = useState();
  const [cities, setCities] = useState([]);
  const [judgmentCity, setJudgmentCity] = useState();

  const [allowGuarantor, setAllowGuarantor] = useState(false);
  const [forInvestor, setForInvestor] = useState(false);
  const [guarantorList, setGuarantorList] = useState([]);
  const [selectedGuarantor, setSelectedGuarantor] = useState();
  const [originalQuantity, setOriginalQuantity] = useState(0); // For tracking quantity changes in edit mode

  const scheduleTypeList = [
    lang.monthly || "Monthly",
    lang.weekly || "Weekly",
    lang.halfyearly || "Half-Yearly",
    lang.yearly || "Yearly",
  ];

  const formatDate = (date) => {
    if (!date) return "";
    const jsDate = new Date(date.toDate ? date.toDate() : date);
    return jsDate.toISOString().split("T")[0];
  };

  // Fetch branchId and all required lists
  useEffect(() => {
    setContractType(pathName.pathname.includes("future") ? 2 : 1);

    // Fetch all necessary data
    Promise.all([
      axios.get(apiKey + "/get-user/customer", {
        params: { branch_id: branchId },
        headers: { Authorization: `Bearer ${token}` },
      }),
      axios.get(apiKey + "/get-accounts", {
        params: { branch_id: branchId },
        headers: { Authorization: `Bearer ${token}` },
      }),
      axios.get(apiKey + "/get-states", {
        headers: { Authorization: `Bearer ${token}` },
      }),
      axios.get(apiKey + "/get-system-inventory/" + branchId, {
        headers: { Authorization: `Bearer ${token}` },
      }),
      axios.get(apiKey + "/description-templates", {
        headers: { Authorization: `Bearer ${token}` },
      }),
    ])
      .then(([customersRes, accountsRes, statesRes, inventoryRes, templatesRes]) => {
        setCustomerList(
          customersRes.data.result.map((item) => ({
            value: item.id,
            label: item.FullName,
          })),
        );
        setAccountList(accountsRes.data.result);
        setCities(statesRes.data.result);
        const mappedItems = inventoryRes.data.result.map((item) => ({
          value: item.id,
          label: item.inventory_name,
          investor: item.investor_id,
          price: item.inventory_price,
          quantity: item.inventory_quantity,
          capital: item.capital,
          inventory_total_price: item.inventory_total_price,
        }));
        setItemsList(mappedItems);
        setDescriptionTemplates(templatesRes.data.data || []);

        // Parse search parameters for auto-filling from contract request
        const queryParams = new URLSearchParams(pathName.search);
        const paramCustomer = queryParams.get("customer");
        const paramItemName = queryParams.get("item_name");
        const paramQuantity = queryParams.get("quantity");
        const paramUnitPrice = queryParams.get("unit_price");
        const paramTotalAmount = queryParams.get("total_amount");
        const paramNoInstallments = queryParams.get("no_installments");
        const paramNotes = queryParams.get("notes");

        if (paramCustomer) {
          setCustomer(parseInt(paramCustomer));
        }
        if (paramQuantity) {
          setQuantity(parseInt(paramQuantity));
        }
        if (paramUnitPrice) {
          setUnitPrice(parseFloat(paramUnitPrice));
        }
        if (paramTotalAmount) {
          setContractValue(parseFloat(paramTotalAmount));
          setTotalSellPrice(parseFloat(paramTotalAmount));
        }
        if (paramNoInstallments) {
          setNoInstallment(parseInt(paramNoInstallments));
        }
        if (paramNotes) {
          setNotes(decodeURIComponent(paramNotes));
          setDescription(decodeURIComponent(paramNotes));
        }

        if (paramItemName && inventoryRes.data.result) {
          const decodedItemName = decodeURIComponent(paramItemName);
          const matchedItem = inventoryRes.data.result.find(
            (i) => i.inventory_name && i.inventory_name.toLowerCase().trim() === decodedItemName.toLowerCase().trim()
          ) || inventoryRes.data.result.find(
            (i) => i.inventory_name && i.inventory_name.toLowerCase().includes(decodedItemName.toLowerCase())
          );

          if (matchedItem) {
            setSelectedItem(matchedItem.id);
            setItem(matchedItem.id);
          }
        }
      })
      .catch(console.error)
      .finally(() => setDataLoading(false));
  }, [branchId, pathName.pathname, token]);
  // Map API data to component state
  const mapContractDataToState = useCallback(
    (data) => {
      // Basic Info
      setCustomer(data.customer_id);

      // Identification Info
      setSelectedItem(data.inventory_contract?.inventory?.inventory_item);
      setItem(data.inventory_contract?.inventory?.inventory_id);
      setInvestor(data.investor_id);
      setQuantity(data.inventory_contract?.quantity);
      setOriginalQuantity(data.inventory_contract?.quantity); // Store original quantity for inventory updates
      setUnitPrice(data.inventory_contract?.unit_sellprice);
      setTotalPurchase(data.final_installment - data.profit || 0);

      // Get inventory details for calculations
      const inventory = data.inventory_contract?.inventory;
      if (inventory) {
        setTotalQuantity(inventory.inventory_quantity);
      }

      // Calculate derived values
      const calculatedTotalSellPrice =
        data.inventory_contract?.unit_sellprice *
        data.inventory_contract?.quantity;
      setTotalSellPrice(calculatedTotalSellPrice);
      setContractValue(data.total_value - (data.legal_fees || 0)); // Subtract legal fees to get base contract value
      setProfit(data.profit);
      setCapital(data.profit);

      // Contract Info
      setContractType(data.contract_type_id);
      setCurrentDate(new Date(data.date_contract));
      setSelectedScheduleType(data.schedule_type);
      setNextScheduledDate(new Date(data.date_1st_installment));
      setDownPayment(data.down_payment);
      setRemaining(data.total_value - data.down_payment);
      setNoInstallment(data.no_of_installments);
      setFinalInstallment(data.final_installment);
      setJudgmentCity(data.judgementCity);
      setLegalFees(data.legal_fees);
      setDescription(data.description);
      setNotes(data.notes);
      setAllowGuarantor(data.allowGuarantor || false);
      setForInvestor(data.forInvestor || false);

      // Account
      if (data.account) {
        setAccount(data.account);
      }

      // Load investors for the selected item
      if (data.inventory_contract?.inventory_id) {
        setInvestorLoading(true);
        axios
          .get(apiKey + "/get-inv-for-contract", {
            params: {
              branchId,
              selectedItem: data.inventory_contract?.inventory?.inventory_item,
            },
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            setInvestors(
              res.data.result.map((item, i) => ({
                value: i + 1,
                item_id: item.id,
                investor: item.investor_id,
                label: item.investor_name,
                price: item.inventory_price,
                quantity: item.inventory_quantity,
                capital: item.capital,
                inventory_total_price: item.inventory_total_price,
              })),
            );
          })
          .catch(console.error)
          .finally(() => setInvestorLoading(false));
      }

      // Load guarantor list if customer exists
      if (data.customer_id) {
        axios
          .get(apiKey + "/get-guarantor?customer_id=" + data.customer_id, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => setGuarantorList(res.data.result))
          .catch(console.error);
      }
    },
    [branchId, token],
  );

  // Load contract data for editing
  useEffect(() => {
    if (id) {
      setIsEditMode(true);
      setLoading(true);
      axios
        .get(`${apiKey}/contract/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          const contractData = res.data;
          mapContractDataToState(contractData);
        })
        .catch((err) => {
          console.error(err);
          toast.error("Error loading contract data");
        })
        .finally(() => setLoading(false));
    }
  }, [id, mapContractDataToState, token]);

  const handleCalendarChange = (calendarType) => {
    setSelectedCalendar(calendarType);
  };

  useEffect(() => {
    if (customer) {
      axios
        .get(apiKey + "/get-guarantor?customer_id=" + customer, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => setGuarantorList(res.data.result))
        .catch(console.error);
    }
  }, [customer, token]);

  useEffect(() => {
    if (selectedItem) {
      axios
        .get(apiKey + "/get-inv-for-contract", {
          params: { branchId, selectedItem },
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          setInvestors(
            res.data.result.map((item, i) => ({
              value: i + 1,
              item_id: item.id,
              investor: item.investor_id,
              label: item.investor_name,
              price: item.inventory_price,
              quantity: item.inventory_quantity,
              capital: item.capital,
              inventory_total_price: item.inventory_total_price,
            })),
          );
        })
        .catch(console.error);
    }
  }, [branchId, selectedItem, token]);

  // All your existing useEffect hooks for calculations
  useEffect(() => {
    if (quantity && totalQuantity < quantity) setAvailable("Unavailable");
    else setAvailable("Available");
  }, [quantity, totalQuantity]);

  useEffect(() => {
    if (quantity && totalSellPrice)
      setUnitPrice((totalSellPrice / quantity).toFixed(2));
  }, [totalSellPrice, quantity]);

  useEffect(() => {
    if (contractValue && downPayment)
      setRemaining(parseFloat(contractValue) - parseFloat(downPayment));
  }, [contractValue, downPayment]);

  const calculateFinalInstallment = useCallback(() => {
    if (remaining && noInstallment && noInstallment > 0) {
      setFinalInstallment((remaining / noInstallment).toFixed(2));
    }
  }, [noInstallment, remaining]);

  const calculateNoInstallment = useCallback(() => {
    if (remaining && finalInstallment && finalInstallment > 0) {
      setNoInstallment(Math.ceil(remaining / finalInstallment));
    }
  }, [finalInstallment, remaining]);

  const calculateNextScheduledDate = useCallback(() => {
    if (!selectedScheduleType) return;

    const currentDate = new Date();
    switch (selectedScheduleType) {
      case "Monthly":
      case lang.monthly:
        currentDate.setMonth(currentDate.getMonth() + 1);
        break;
      case "Weekly":
      case lang.weekly:
        currentDate.setDate(currentDate.getDate() + 7);
        break;
      case "Half-Yearly":
      case lang.halfyearly:
        currentDate.setMonth(currentDate.getMonth() + 6);
        break;
      case "Yearly":
      case lang.yearly:
        currentDate.setFullYear(currentDate.getFullYear() + 1);
        break;
      default:
        break;
    }
    setNextScheduledDate(currentDate);
  }, [selectedScheduleType, lang]);

  const calculateLastInstallmentDate = useCallback(() => {
    if (!nextScheduledDate || !selectedScheduleType || !noInstallment) return null;

    const startDate = new Date(
      nextScheduledDate.toDate ? nextScheduledDate.toDate() : nextScheduledDate
    );
    if (isNaN(startDate.getTime())) return null;

    const count = parseInt(noInstallment) || 1;
    if (count <= 1) return startDate;

    const lastDate = new Date(startDate);
    const intervalsToAdd = count - 1;

    switch (selectedScheduleType) {
      case "Monthly":
      case lang.monthly:
        lastDate.setMonth(lastDate.getMonth() + intervalsToAdd);
        break;
      case "Weekly":
      case lang.weekly:
        lastDate.setDate(lastDate.getDate() + intervalsToAdd * 7);
        break;
      case "Half-Yearly":
      case lang.halfyearly:
        lastDate.setMonth(lastDate.getMonth() + intervalsToAdd * 6);
        break;
      case "Yearly":
      case lang.yearly:
        lastDate.setFullYear(lastDate.getFullYear() + intervalsToAdd);
        break;
      default:
        break;
    }
    return lastDate;
  }, [nextScheduledDate, selectedScheduleType, noInstallment, lang]);

  useEffect(() => {
    if (contractType == 2) {
      setNoInstallment(1);
    }
  }, [contractType]);

  useEffect(() => {
    calculateNextScheduledDate();
  }, [calculateNextScheduledDate, selectedScheduleType]);

  const handleSubmit = () => {
    const requiredFields = [
      { value: contractType, name: "Contract Type" },
      { value: customer, name: "Customer" },
      { value: investor, name: "Investor" },
      { value: quantity, name: "Quantity" },
      { value: item, name: "Item" },
      { value: unitPrice, name: "Unit Price" },
      // { value: account, name: "Account" },
      // { value: currentDate, name: "Date" },
      { value: selectedScheduleType, name: "Schedule Type" },
      { value: nextScheduledDate, name: "Next Scheduled Date" },
      { value: profit, name: "Profit" },
      // { value: premium, name: "Premium" },
      { value: downPayment, name: "Down Payment" },
      { value: finalInstallment, name: "Final Installment" },
      { value: noInstallment, name: "No. of Installments" },
      { value: remaining, name: "Remaining Amount" },
      // { value: branchId, name: "Branch" },
      { value: legalFees, name: "Legal Fees" },
      { value: description, name: "Description" },
      { value: judgmentCity, name: "Judgment City" },
      { value: forInvestor, name: "For Investor"}
      // { value: allowGuarantor, name: "Guarantor Permission" },
      // { value: selectedGuarantor, name: "Guarantor" },
      // { value: notes, name: "Notes" },
    ];

    for (const field of requiredFields) {
      if (
        field.value === null ||
        field.value === undefined ||
        field.value === ""
      ) {
        toast.error(`${field.name} is required`);
        return;
      }
    }

    if (isEditMode) {
      handleUpdate();
    } else {
      if (available === "Available") {
        handleCreate();
      } else {
        toast.error("Item is unavailable");
      }
    }
  };

  const handleCreate = () => {
    const finalContractValue =
      parseFloat(contractValue) + parseFloat(legalFees || 0);

    axios
      .post(
        apiKey + "/create-installment-contract",
        {
          contractType,
          customer,
          investor,
          quantity,
          item,
          unitPrice,
          account,
          currentDate: formatDate(currentDate),
          selectedScheduleType,
          nextScheduledDate: formatDate(nextScheduledDate),
          contractValue: finalContractValue,
          profit,
          // premium,
          downPayment,
          finalInstallment,
          noInstallment,
          remaining,
          branch_id: branchId,
          legal_fees: legalFees,
          description,
          judgmentCity,
          allowGuarantor,
          guarantor: selectedGuarantor,
          notes,
          forInvestor,
          application_id: new URLSearchParams(pathName.search).get("application_id") || null,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        toast.success(res.data.Message);
        navigate(
          "/dashboard/customer/contract-information/" +
          res.data.contract_id,
        );
      })
      .catch((err) => {
        console.error(err);
        toast.error(err.response.data.Error || "Error Occurred");
      });
  };

  const handleUpdate = () => {
    const finalContractValue =
      parseFloat(contractValue) + parseFloat(legalFees || 0);

    axios
      .put(
        `${apiKey}/edit-installment-contract/${id}`,
        {
          contractType,
          customer,
          investor,
          quantity,
          item,
          unitPrice,
          account,
          currentDate: formatDate(currentDate),
          selectedScheduleType,
          nextScheduledDate: formatDate(nextScheduledDate),
          contractValue: finalContractValue,
          profit,
          // premium,
          downPayment,
          finalInstallment,
          noInstallment,
          branch_id: branchId,
          legal_fees: legalFees,
          description,
          judgmentCity,
          allowGuarantor,
          guarantor: selectedGuarantor,
          notes,
          originalQuantity, // Send original quantity for inventory adjustment
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        toast.success("Contract updated successfully");
        navigate(`/dashboard/customer/contract-information/${id}`);
      })
      .catch((err) => {
        console.error(err);
        toast.error(err.response.data.Error || "Error updating contract");
      });
  };

  // useEffect(() => {
  //   calculateFinalInstallment();
  //   calculateNoInstallment();
  // }, [calculateFinalInstallment, calculateNoInstallment, totalPurchase, totalSellPrice]);

  // Remove this problematic useEffect entirely:
  // useEffect(() => {
  //   calculateFinalInstallment();
  //   calculateNoInstallment();
  // }, [calculateFinalInstallment, calculateNoInstallment, totalPurchase, totalSellPrice]);

  // Update your total selling price handler to include installment calculations:
  const handleTotalSellPriceChange = (e) => {
    const newTotalSellPrice = parseFloat(e.target.value) || 0;
    setTotalSellPrice(newTotalSellPrice);
    setContractValue(newTotalSellPrice);

    // Calculate profit and capital
    const newProfit = newTotalSellPrice - (totalPurchase || 0);
    setCapital(newProfit);
    setProfit(newProfit);

    // Recalculate remaining amount and installments
    const newRemaining = newTotalSellPrice - (downPayment || 0);
    setRemaining(newRemaining);

    // Recalculate installments based on new remaining amount
    if (newRemaining > 0) {
      if (noInstallment && noInstallment > 0) {
        setFinalInstallment((newRemaining / noInstallment).toFixed(2));
      } else if (finalInstallment && finalInstallment > 0) {
        setNoInstallment(Math.ceil(newRemaining / finalInstallment));
      }
    }
  };

  // Update your total purchase price handler:
  const handleTotalPurchaseChange = (e) => {
    const newTotalPurchase = parseFloat(e.target.value) || 0;
    setTotalPurchase(newTotalPurchase);

    // Recalculate profit when purchase price changes
    if (totalSellPrice) {
      const newProfit = totalSellPrice - newTotalPurchase;
      setCapital(newProfit);
      setProfit(newProfit);
    }
  };

  // Update your down payment handler:
  const handleDownPaymentChange = (e) => {
    const newDownPayment = parseFloat(e.target.value) || 0;
    setDownPayment(newDownPayment);

    // Recalculate remaining and installments
    if (contractValue) {
      const newRemaining = contractValue - newDownPayment;
      setRemaining(newRemaining);

      // Recalculate installments based on new remaining amount
      if (newRemaining > 0) {
        if (noInstallment && noInstallment > 0) {
          setFinalInstallment((newRemaining / noInstallment).toFixed(2));
        } else if (finalInstallment && finalInstallment > 0) {
          setNoInstallment(Math.ceil(newRemaining / finalInstallment));
        }
      } else {
        // If remaining is 0 or negative, reset installments
        setFinalInstallment(0);
        setNoInstallment(0);
      }
    }
  };

  if (loading || dataLoading || investorLoading) return <div>Loading...</div>;

  return (
    <main id="main" className="main">
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        theme="colored"
      />
      <div className="pagetitle">
        <h1>
          {isEditMode
            ? lang.Edit_Contract || "Edit Contract"
            : lang.General_Management || "General Management"}
        </h1>
      </div>
      <div className="card">
        {/* Your existing JSX structure remains the same with proper value mappings */}
        {/* ... All your form sections with proper default values ... */}
        {/* Tabs and all sections UI go here. You can structure using headings and grouping inputs as per sections: BasicInfo, Identification, ContractInfo */}
        {/* Keep form structure and field blocks similar to original components */}
        <div
          className="card-body"
          style={{
            overflow: "visible",
          }}
        >
          <div className="d-flex mt-3 mb-3">
            <h4 className="headingh4 fw-bold">
              {lang.Basic_Information || "Basic Information"}
            </h4>
          </div>
          <form>
            <div className="row mb-3 d-flex justify-content-center">
              <div className="col-lg-4">
                <label htmlFor="customer" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Client || "Client"}:
                  </span>
                  {customerList.length > 0 && (
                    <Select
                      id="itemName"
                      options={customerList}
                      placeholder={""}
                      required
                      onChange={(e) => {
                        setCustomer(e.value);
                      }}
                      defaultValue={{
                        value: customer,
                        label:
                          customerList.find((c) => c.value === customer)
                            ?.label || "",
                      }}
                    />
                  )}
                </label>
              </div>
            </div>
          </form>
        </div>
        <div className="card-body">
          <div className="d-flex mt-3 mb-3">
            <h4 className="headingh4 fw-bold">
              {lang.Identification_of_Goods || "Identification of Goods"}
            </h4>
          </div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              // handleSubmit();
            }}
          >
            <div className="row mb-3 d-flex justify-content-center">
              <div className="col-lg-4">
                <label htmlFor="itemName" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Item_Name || "Item Name"}:
                  </span>
                  <Select
                    id="itemName"
                    options={itemsList}
                    required
                    placeholder={""}
                    onChange={(e) => {
                      setSelectedItem(e.value);
                      setTotalQuantity(e.quantity);
                      setItem(e.item_id);
                    }}
                    defaultValue={{
                      value: selectedItem,
                      label:
                        itemsList.find((c) => c.value === selectedItem)
                          ?.label || "",
                    }}
                  />
                </label>
              </div>

              <div className="col-lg-4">
                <label htmlFor="investor" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Investor || "Investor"}:
                  </span>
                  <Select
                    options={investors}
                    required
                    placeholder={""}
                    onChange={(e) => {
                      setInvestor(e.investor);
                      setTotalQuantity(e.quantity);
                      setItem(e.item_id);
                    }}
                    defaultValue={{
                      value: investor,
                      label:
                        investors.find((c) => c.investor === investor)?.label ||
                        "",
                    }}
                  />
                </label>
              </div>
            </div>

            <div className="row mb-3 d-flex justify-content-center">
              <div className="col-lg-4">
                <label htmlFor="quantity" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Quantity || "Quantity"}:
                  </span>
                  <input
                    id="quantity"
                    type="text"
                    className="form-control"
                    value={quantity}
                    onChange={(e) => {
                      setQuantity(parseInt(e.target.value) || 0);
                    }}
                    required
                  />
                </label>
              </div>
              <div className="col-lg-4">
                <label htmlFor="available" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Available || "Available"}:
                  </span>
                  <input
                    id="available"
                    type="text"
                    className="form-control"
                    value={available}
                    readOnly
                  />
                </label>
              </div>
            </div>

            <div className="row mb-3 d-flex justify-content-center">
              <div className="col-lg-4">
                <label htmlFor="unitPrice" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.total_purchase_price || "Total Purchase Price"}
                  </span>
                  <input
                    id="unitPrice"
                    type="text"
                    className="form-control"
                    // onChange={(e) =>
                    //   setTotalPurchase(parseInt(e.target.value) || 0)
                    // }
                    onChange={handleTotalPurchaseChange}
                    value={totalPurchase}
                    required
                  />
                </label>
              </div>
              <div className="col-lg-4">
                <label htmlFor="capital" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.total_selling_price || "Total Selling Price"}
                  </span>
                  <input
                    id="capital"
                    type="text"
                    className="form-control"
                    value={totalSellPrice}
                    // onChange={(e) => {
                    //   setTotalSellPrice(e.target.value);
                    //   setContractValue(e.target.value);
                    //   setCapital(e.target.value - totalPurchase);
                    //   setProfit(e.target.value - totalPurchase);
                    // }}
                    onChange={handleTotalSellPriceChange}
                  // disabled
                  />
                </label>
              </div>
            </div>

            <div className="row mb-3 d-flex justify-content-center">
              <div className="col-lg-4">
                <label htmlFor="unitPrice" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Unit_Selling_Price || "Unit Selling Price"}:
                  </span>
                  <input
                    id="unitPrice"
                    type="text"
                    className="form-control"
                    value={unitPrice || 0}
                    // onChange={(e) =>
                    //   setUnitPrice(parseInt(e.target.value))
                    // }
                    readOnly
                    required
                  />
                </label>
              </div>
              <div className="col-lg-4">
                <label htmlFor="capital" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.total_profit || "Total Profit"}:
                  </span>
                  <input
                    id="capital"
                    type="text"
                    className="form-control"
                    value={capital}
                    disabled
                  />
                </label>
              </div>
            </div>

            <div className="row mb-3 d-flex justify-content-center">
              <div className="col-lg-4">
                <label htmlFor="profit" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Profit_Ratio || "Profit Ratio"}:
                  </span>
                  <input
                    id="profit"
                    type="email"
                    className="form-control"
                    value={profit || 0}
                    disabled
                  />
                </label>
              </div>
              <div className="col-lg-4">
                <label htmlFor="profit" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.legal_fees || "Legal Fees"}:
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    value={legalFees}
                    onChange={(e) =>
                      setLegalFees(parseInt(e.target.value) || 0)
                    }
                  />
                </label>
              </div>
            </div>
            <div className="row mb-3 d-flex justify-content-center">
              <div className="col-lg-8">
                <label htmlFor="" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang["Select Template"] || "Select Template"}:
                  </span>
                  <select
                    className="form-select mb-2"
                    onChange={(e) => {
                      if (e.target.value) {
                        const selectedTpl = descriptionTemplates.find(t => t.id == e.target.value);
                        if (selectedTpl) setDescription(selectedTpl.description);
                      }
                    }}
                  >
                    <option value="">{lang["Custom"] || "Custom / None"}</option>
                    {descriptionTemplates.map((tpl) => (
                      <option key={tpl.id} value={tpl.id}>
                        {tpl.description.substring(0, 50)}{tpl.description.length > 50 ? "..." : ""}
                      </option>
                    ))}
                  </select>
                </label>
                <label htmlFor="" className="w-100 mt-2">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Description || "Description"}:
                  </span>
                  <textarea
                    className="form-control"
                    rows="5"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                  ></textarea>
                </label>
              </div>
            </div>
          </form>
        </div>
        <div className="card-body">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              // handleSubmit();
            }}
          >
            <div className="d-flex flex-column-reverse flex-lg-row mt-3 mb-3 justify-content-end">
              <label className="select-calendar mt-3 mt-lg-0">
                <span style={{ fontSize: "14px" }}>
                  {lang.select_calendar || "Select Calendar"}:
                </span>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="arabicRadio"
                    value="arabic"
                    checked={selectedCalendar === "arabic"}
                    onChange={() => handleCalendarChange("arabic")}
                  />
                  <label className="form-check-label" htmlFor="arabicRadio">
                    {lang.arabic || "Arabic"}
                  </label>
                </div>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="gregorianRadio"
                    value="gregorian"
                    checked={selectedCalendar === "gregorian"}
                    onChange={() => handleCalendarChange("gregorian")}
                  />
                  <label className="form-check-label" htmlFor="gregorianRadio">
                    {lang.gregorian || "Gregorian"}
                  </label>
                </div>
              </label>
            </div>
            <div className="row mb-3 d-flex justify-content-center">
              <div className="col-lg-4">
                <label htmlFor="contractType" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Type_of_Contract || "Type of Contract"}:
                  </span>
                  <select value={contractType} onChange={(e) => setContractType(e.target.value)} className="form-select">
                    <option value={1}>{lang["Installment"]}</option>
                    <option value={2}>{lang["Future"]}</option>
                  </select>
                </label>
              </div>
              <div className="col-lg-4">
                <label htmlFor="contractDate" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Date_of_Contract || "Date of Contract (YYYY/MM/DD)"}:
                  </span>
                  <DatePicker
                    className="form-control w-100"
                    containerStyle={{
                      width: "100%",
                      height: "100%",
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                      margin: "0",
                    }}
                    calendar={selectedCalendar === "arabic" ? arabic : ""}
                    locale={selectedCalendar === "arabic" ? arabic_ar : ""}
                    value={currentDate}
                    disabled
                  />
                </label>
              </div>
            </div>

            <div className="row mb-3 d-flex justify-content-center">
              <div className="col-lg-4">
                <label htmlFor="scheduleType" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Schedule_Type || "Schedule Type"}:
                  </span>
                  <select
                    id="scheduleType"
                    className="form-select"
                    aria-label="Default select example"
                    value={selectedScheduleType}
                    onChange={(e) => {
                      setSelectedScheduleType(e.target.value);
                    }}
                    required
                  >
                    <option selected disabled></option>
                    {scheduleTypeList.map((type, index) => (
                      <option key={index} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
              <div className="col-lg-4">
                <label htmlFor="nextScheduledDate" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Date_of_1st_Installment || "Date of 1st installment"}:
                  </span>
                  <DatePicker
                    className="form-control w-100"
                    containerStyle={{
                      width: "100%",
                      height: "100%",
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                      margin: "0",
                    }}
                    calendar={selectedCalendar === "arabic" ? arabic : ""}
                    locale={selectedCalendar === "arabic" ? arabic_ar : ""}
                    value={nextScheduledDate}
                    minDate={new Date(currentDate)}
                    onChange={(e) => {
                      setNextScheduledDate(e);
                    }}
                  />
                </label>
              </div>
            </div>

            <div className="row mb-3 d-flex justify-content-center">
              <div className="col-lg-4">
                <label htmlFor="contractValue" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Contract_Value || "Contract Value"}:
                  </span>
                  <input
                    id="contractValue"
                    type="text"
                    className="form-control"
                    value={parseFloat(contractValue) + parseFloat(legalFees)}
                    disabled
                    required
                  />
                </label>
              </div>
              <div className="col-lg-4">
                <label htmlFor="profit" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Profit || "Profit"}:
                  </span>
                  <input
                    id="profit"
                    type="text"
                    className="form-control"
                    value={profit}
                    disabled
                    required
                  />
                </label>
              </div>
            </div>

            <div className="row mb-3 d-flex justify-content-center">
              <div className="col-lg-4">
                <label htmlFor="account" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Account_for_Payments || "Account for payments"}:
                  </span>
                  <select
                    id="account"
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => {
                      setAccount(e.target.value);
                    }}
                    required
                  >
                    <option selected disabled></option>
                    {accountList.map((account) => (
                      <option key={account.id} value={account.account_number}>
                        {account.account_name}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
              <div className="col-lg-4">
                <label htmlFor="downPayment" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Down_Payment || "Down Payment"}:
                  </span>
                  <input
                    id="downPayment"
                    type="text"
                    className="form-control"
                    value={downPayment}
                    // onChange={(e) => setDownPayment(e.target.value)}
                    onChange={handleDownPaymentChange}
                    required
                  />
                </label>
              </div>
            </div>

            <div className="row mb-3 d-flex justify-content-center">
              <div className="col-lg-4">
                <label htmlFor="remaining" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Remaining_amount || "Remaining Amount"}:
                  </span>
                  <input
                    id="remaining"
                    type="text"
                    className="form-control"
                    value={remaining || ""}
                    disabled
                    required
                  />
                </label>
              </div>
              <div className="col-lg-4">
                <label htmlFor="noInstallment" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Number_of_Installments || "Number of Installments"}:
                  </span>
                  <input
                    id="noInstallment"
                    type="text"
                    className="form-control"
                    value={noInstallment || ""}
                    onChange={(e) => {
                      const value = parseInt(e.target.value) || 0;
                      setNoInstallment(value);
                      // Auto-calculate final installment when number of installments changes
                      if (remaining && value > 0) {
                        setFinalInstallment((remaining / value).toFixed(2));
                      }
                    }}
                    onBlur={calculateFinalInstallment} // Calculate on blur as well
                    disabled={contractType == 2}
                    required
                  />
                </label>
              </div>
            </div>

            <div className="row mb-3 d-flex justify-content-center">
              <div className="col-lg-4">
                <label htmlFor="finalInstallment" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Final_Installment || "Final Installment"}:
                  </span>
                  <input
                    id="finalInstallment"
                    type="text"
                    className="form-control"
                    value={finalInstallment || ""}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value) || 0;
                      setFinalInstallment(value);
                      // Auto-calculate number of installments when final installment changes
                      if (remaining && value > 0) {
                        setNoInstallment(Math.ceil(remaining / value));
                      }
                    }}
                    onBlur={calculateNoInstallment} // Calculate on blur as well
                    required
                  />
                </label>
              </div>
              <div className="col-lg-4">
                <label htmlFor="" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.judgement_city || "Judgement City"}:
                  </span>
                  <select
                    name=""
                    id=""
                    className="form-select"
                    onChange={(e) => setJudgmentCity(e.target.value)}
                    value={judgmentCity}
                    required
                  >
                    <option selected disabled></option>
                    {cities.map((state) => (
                      <option key={state.city_id} value={state.city_id}>
                        {lang.Lang === "en" ? state.name_en : state.name_ar}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
            </div>
            <div className="row mb-3 d-flex justify-content-center">
              <div className="col-lg-4">
                <label htmlFor="lastInstallmentDate" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang["Date of Last Installment"] || "Date of Last Installment"}:
                  </span>
                  <DatePicker
                    id="lastInstallmentDate"
                    className="form-control w-100"
                    containerStyle={{
                      width: "100%",
                      height: "100%",
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                      margin: "0",
                    }}
                    calendar={selectedCalendar === "arabic" ? arabic : ""}
                    locale={selectedCalendar === "arabic" ? arabic_ar : ""}
                    value={calculateLastInstallmentDate()}
                    disabled
                  />
                </label>
              </div>
              <div className="col-lg-4"></div>
            </div>
            <div className="row mb-3 d-flex justify-content-center">
              <div className="col-sm-4">
                <label htmlFor="" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang["Allow Guarantor"] || "Allow Guarantor"}
                  </span>
                  <div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="light_mode"
                        id="l_yes"
                        value={"yes"}
                        checked={allowGuarantor === true}
                        onChange={() => setAllowGuarantor(true)}
                      />
                      <label className="form-check-label" htmlFor="l_yes">
                        {lang["Yes"] || "Yes"}
                      </label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="light_mode"
                        id="l_no"
                        value={"no"}
                        checked={allowGuarantor === false}
                        onChange={() => setAllowGuarantor(false)}
                      />
                      <label className="form-check-label" htmlFor="l_no">
                        {lang["No"] || "No"}
                      </label>
                    </div>
                  </div>
                </label>
              </div>
              <div className="col-sm-4">
                <label htmlFor="" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang["For Investor?"] || "For Investor?"}
                  </span>
                  <div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="for_investor"
                        id="i_yes"
                        value={"yes"}
                        checked={forInvestor === true}
                        onChange={() => setForInvestor(true)}
                      />
                      <label className="form-check-label" htmlFor="i_yes">
                        {lang["Yes"] || "Yes"}
                      </label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="for_investor"
                        id="i_no"
                        value={"no"}
                        checked={forInvestor === false}
                        onChange={() => setForInvestor(false)}
                      />
                      <label className="form-check-label" htmlFor="i_no">
                        {lang["No"] || "No"}
                      </label>
                    </div>
                  </div>
                </label>
              </div>
            </div>
            {allowGuarantor && (
              <div className="row mb-3 d-flex justify-content-center">
                <div className="col-lg-4">
                  <label htmlFor="guarantor1" className="w-100">
                    <span style={{ fontSize: "14px" }}>
                      {lang.Select_Guarantor || "Select Guarantor"}:
                    </span>
                    <select
                      id="guarantor1"
                      className="form-select"
                      aria-label="Default select example"
                      onChange={(e) => setSelectedGuarantor(e.target.value)}
                    >
                      <option defaultValue="">Select Guarantor</option>
                      {guarantorList.map((guarantor) => (
                        <option key={guarantor.id} value={guarantor.id}>
                          {guarantor.FullName}
                        </option>
                      ))}
                    </select>
                  </label>
                </div>
              </div>
            )}
            <div className="row mb-3 d-flex justify-content-center">
              <div className="col-lg-8">
                <label htmlFor="" className="w-100">
                  <span style={{ fontSize: "14px" }}>
                    {lang.Note || "Notes"}:
                  </span>
                  <textarea
                    className="form-control"
                    rows="5"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    required
                  ></textarea>
                </label>
              </div>
            </div>
          </form>
        </div>
        {/* Submit and Cancel buttons */}
        <div className="d-flex justify-content-end mt-4">
          <button className="btn btn-secondary" onClick={() => navigate(-1)}>
            {lang.Cancel || "Cancel"}
          </button>
          <button className="btn btn-primary ms-3" onClick={handleSubmit}>
            {isEditMode
              ? lang.Update_Contract || "Update Contract"
              : lang.Save_And_Next || "Save & Submit"}
          </button>
        </div>
      </div>
    </main>
  );
}
